/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DisplayPeriod } from './DisplayPeriod';
import {
    DisplayPeriodFromJSON,
    DisplayPeriodFromJSONTyped,
    DisplayPeriodToJSON,
    DisplayPeriodToJSONTyped,
} from './DisplayPeriod';

/**
 * 
 * @export
 * @interface RetailerNotificationMessage
 */
export interface RetailerNotificationMessage {
    /**
     * 
     * @type {number}
     * @memberof RetailerNotificationMessage
     */
    notificationId: number;
    /**
     * 
     * @type {string}
     * @memberof RetailerNotificationMessage
     */
    message: string;
    /**
     * 
     * @type {boolean}
     * @memberof RetailerNotificationMessage
     */
    acknowledgeable: boolean;
    /**
     * 
     * @type {DisplayPeriod}
     * @memberof RetailerNotificationMessage
     */
    displayPeriod: DisplayPeriod;
    /**
     * 
     * @type {string}
     * @memberof RetailerNotificationMessage
     */
    displayClass: string;
}

/**
 * Check if a given object implements the RetailerNotificationMessage interface.
 */
export function instanceOfRetailerNotificationMessage(value: object): value is RetailerNotificationMessage {
    if (!('notificationId' in value) || value['notificationId'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('acknowledgeable' in value) || value['acknowledgeable'] === undefined) return false;
    if (!('displayPeriod' in value) || value['displayPeriod'] === undefined) return false;
    if (!('displayClass' in value) || value['displayClass'] === undefined) return false;
    return true;
}

export function RetailerNotificationMessageFromJSON(json: any): RetailerNotificationMessage {
    return RetailerNotificationMessageFromJSONTyped(json, false);
}

export function RetailerNotificationMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): RetailerNotificationMessage {
    if (json == null) {
        return json;
    }
    return {
        
        'notificationId': json['notificationId'],
        'message': json['message'],
        'acknowledgeable': json['acknowledgeable'],
        'displayPeriod': DisplayPeriodFromJSON(json['displayPeriod']),
        'displayClass': json['displayClass'],
    };
}

export function RetailerNotificationMessageToJSON(json: any): RetailerNotificationMessage {
    return RetailerNotificationMessageToJSONTyped(json, false);
}

export function RetailerNotificationMessageToJSONTyped(value?: RetailerNotificationMessage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'notificationId': value['notificationId'],
        'message': value['message'],
        'acknowledgeable': value['acknowledgeable'],
        'displayPeriod': DisplayPeriodToJSON(value['displayPeriod']),
        'displayClass': value['displayClass'],
    };
}

